import { render, staticRenderFns } from "./ProstateResultsForm.vue?vue&type=template&id=940f7196&scoped=true&"
import script from "./ProstateResultsForm.vue?vue&type=script&lang=js&"
export * from "./ProstateResultsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProstateResultsForm.vue?vue&type=style&index=0&id=940f7196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940f7196",
  null
  
)

export default component.exports